import { AccessType, AccessPermission, AccessRole } from 'src/constants';

let isAdmin = false;
let isSuperAdmin = false;

export const setIsAdmin = (value = false, superAdmin = false) => {
  if (superAdmin) {
    isSuperAdmin = value;
  }

  isAdmin = value;
};

export const getIsAdmin = (isSuper = false) =>
  isSuper ? isSuperAdmin : isAdmin;

export const getUserType = () => {
  if (isSuperAdmin) {
    return AccessRole.SUPER_ADMIN;
  }

  return isAdmin ? AccessRole.ADMIN : AccessRole.GENERAL;
};

export type IHasAccessType = AccessType | AccessType[];

const flattenList = (type: IHasAccessType) => {
  return (Array.isArray(type) ? type : [type]).reduce(
    (a: AccessType[], b) =>
      Array.isArray(b) ? [...a, ...flattenList(b)] : [...a, b],
    []
  );
};

export const hasAccess = (type: IHasAccessType) => {
  const list = flattenList(type);

  const user = getUserType();
  const isAuthorizedAdmin =
    user === AccessRole.SUPER_ADMIN
      ? [AccessRole.SUPER_ADMIN, AccessRole.ADMIN]
      : [AccessRole.ADMIN];

  // This will only checks access type designated only for super admin
  if (
    list.every(
      (value) =>
        Array.isArray(AccessPermission[AccessRole.SUPER_ADMIN]) &&
        AccessPermission[AccessRole.SUPER_ADMIN].includes(value)
    )
  ) {
    return user === AccessRole.SUPER_ADMIN;
  }

  return list.every(
    (value) =>
      isAuthorizedAdmin.includes(user) ||
      (Array.isArray(AccessPermission[user]) &&
        AccessPermission[user]?.includes(value))
  );
};
